import React from 'react';
import { Building2, Stethoscope, Bus, Zap, ShieldAlert, Recycle } from 'lucide-react';
import SectionDirectory from '../components/SectionDirectory';

const GROUPS = [
  {
    name: 'Council services',
    icon: <Building2 size={17} />,
    blurb: 'Renfrewshire Council — the everyday essentials.',
    links: [
      { name: 'Renfrewshire Council', url: 'https://www.renfrewshire.gov.uk', note: 'Main site — 0300 300 0300' },
      { name: 'Council tax', url: 'https://www.renfrewshire.gov.uk/council-tax' },
      { name: 'Report a problem', url: 'https://www.renfrewshire.gov.uk/report-it', note: 'Potholes, street lights, fly-tipping' },
      { name: 'Schools & term dates', url: 'https://www.renfrewshire.gov.uk/schools' },
      { name: 'Planning applications', url: 'https://www.renfrewshire.gov.uk/planning' },
    ],
  },
  {
    name: 'Bins & recycling',
    icon: <Recycle size={17} />,
    links: [
      { name: 'Bin collection days', url: 'https://www.renfrewshire.gov.uk/bins' },
      { name: 'Recycling centres', url: 'https://www.renfrewshire.gov.uk/recycling', note: 'Underwood Road and Erskine' },
      { name: 'Bulky uplift', url: 'https://www.renfrewshire.gov.uk/bulky-uplift' },
    ],
  },
  {
    name: 'Health',
    icon: <Stethoscope size={17} />,
    links: [
      { name: 'NHS 24 — call 111', url: 'https://www.nhs24.scot', note: 'When it is urgent but not an emergency' },
      { name: 'NHS Greater Glasgow & Clyde', url: 'https://www.nhsggc.scot', note: 'Includes the Royal Alexandra Hospital, Paisley' },
      { name: 'NHS Inform Scotland', url: 'https://www.nhsinform.scot', note: 'Symptoms, services and self-help guides' },
      { name: 'Find a GP or dentist', url: 'https://www.nhsinform.scot/scotlands-service-directory' },
    ],
  },
  {
    name: 'Travel',
    icon: <Bus size={17} />,
    links: [
      { name: 'Roads & travel on paisley.org.uk', url: '/roads-and-travel', internal: true, note: 'Live cameras and trunk road updates' },
      { name: 'Incident Watch', url: '/incident-watch', internal: true, note: 'Live local incident monitoring' },
      { name: 'McGill\'s Buses', url: 'https://www.mcgillsbuses.co.uk', note: 'The main local operator' },
      { name: 'ScotRail', url: 'https://www.scotrail.co.uk', note: 'Paisley Gilmour Street and Canal' },
      { name: 'SPT', url: 'https://www.spt.co.uk', note: 'Strathclyde travel information' },
      { name: 'Glasgow Airport', url: 'https://www.glasgowairport.com' },
      { name: 'Traffic Scotland', url: 'https://www.trafficscotland.org', note: 'Trunk roads and motorways' },
    ],
  },
  {
    name: 'Utilities & outages',
    icon: <Zap size={17} />,
    links: [
      { name: 'Power cuts — call 105', url: 'https://www.spenergynetworks.co.uk/pages/power_cuts.aspx', note: 'SP Energy Networks' },
      { name: 'Scottish Water', url: 'https://www.scottishwater.co.uk', note: 'Supply problems and burst mains' },
      { name: 'Gas emergency — 0800 111 999', url: 'https://www.cadentgas.com/emergency', note: 'If you smell gas, call first' },
      { name: 'Scottish Road Works Register', url: 'https://roadworks.scot', note: 'Every registered street closure in Scotland' },
    ],
  },
  {
    name: 'Emergencies & safety',
    icon: <ShieldAlert size={17} />,
    blurb: 'In an emergency always dial 999.',
    links: [
      { name: 'Police Scotland — 101 non-emergency', url: 'https://www.scotland.police.uk' },
      { name: 'Scottish Fire & Rescue Service', url: 'https://www.firescotland.gov.uk', note: 'Free home fire safety visits' },
      { name: 'Met Office weather warnings', url: 'https://www.metoffice.gov.uk/weather/warnings-and-advice/uk-warnings' },
      { name: 'Floodline Scotland — 0345 988 1188', url: 'https://www.floodlinescotland.org.uk' },
    ],
  },
];

const UsefulInfoPage = () => (
  <SectionDirectory
    kicker="Paisley & Renfrewshire"
    title="Useful Information"
    intro="Council services, health, travel, utilities and emergency numbers — the things you actually need, without digging through menus."
    seo={{
      title: 'Useful information for Paisley & Renfrewshire — council, health, travel and emergencies',
      description: 'Council services, bins and recycling, NHS contacts, travel and transport, power and water outages, and emergency numbers for Paisley and Renfrewshire.',
      url: '/useful-information',
    }}
    groups={GROUPS}
    footnote="Phone numbers and links are provided for convenience and belong to the organisations named. In an emergency always dial 999. If something here is out of date, please tell us."
  />
);

export default UsefulInfoPage;
